import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { SnackbarNotifComponent } from './snackbar-notif/snackbar-notif.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private _snackBar: MatSnackBar) { }
  showNotification(message) {
    const options: any = {
      duration: 7000,
      data: message,
      verticalPosition: 'top',
      panelClass: ['notification']
    };
    this._snackBar.openFromComponent(SnackbarNotifComponent, options);
  }
  openSnackBar(message: string, action: string = '', type = 'success', duration=2000) {
    let className = 'success-snack-bar';
    if(type == 'err' || type == 'error'){
      className = 'error-snack-bar';
    }
    if (type == 'warn' || type == 'warning') {
      className = 'warning-snack-bar';
    }
    this._snackBar.open(message, action, {
      duration: duration,
      panelClass: [className]
    });
  }
}
